/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Delivery progress, velocity, and rate-limit widgets.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {AppSharedModule} from '../app-shared.module';
import {FormControlsModule} from '../directives/form-controls/form-controls.module';
import {PercentageBarComponent} from './progress-bar-percentage-component';
import {VelocityComponent} from './velocity-component';
import {RateLimitComponent} from './rate-limit.component';

const DELIVERY_WIDGETS = [
  PercentageBarComponent,
  VelocityComponent,
  RateLimitComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    FormControlsModule
  ],
  declarations: DELIVERY_WIDGETS,
  exports: DELIVERY_WIDGETS
})
export class DeliveryWidgetsModule {
}
